import { type ReactNode } from "react";
import { Tabs } from "./Tabs.js";
import { EnvBadge } from "./EnvBadge.js";

type Props = {
  // Shown on the left of the header. Defaults to a generic product
  // title; pages can override with something more specific.
  title?: string;
  // Optional small content area between title and sign-out — typically
  // used by pages to surface signed-in user info ("Signed in as …").
  userEmail?: string | undefined;
  children: ReactNode;
  onSignOut?: () => void;
};

const TOP_TABS = [
  { label: "Appointments", to: "/" },
  { label: "Schedule", to: "/settings/schedule" },
  { label: "Settings", to: "/settings" },
];

export function Layout({ title, userEmail, children, onSignOut }: Props) {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-6 pt-4">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <p className="text-lg font-semibold text-slate-900">
                {title ?? "PriCare admin"}
              </p>
              <EnvBadge />
            </div>
            <div className="flex items-center gap-4">
              {userEmail ? (
                <span className="hidden text-xs text-slate-500 sm:inline">
                  {userEmail}
                </span>
              ) : null}
              {onSignOut ? (
                <button
                  type="button"
                  onClick={onSignOut}
                  className="text-sm font-medium text-slate-600 hover:text-slate-900"
                >
                  Sign out
                </button>
              ) : null}
            </div>
          </div>
          <Tabs tabs={TOP_TABS} className="mt-4" />
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-6">{children}</main>
    </div>
  );
}
